import { type Job } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

export interface SetJobRecruitersInput {
  id: string;
  userIds: string[];
}

/** Admin-only: replace the set of additional recruiters on a job.
 * Invalidates the single-job cache + the job lists so all consumers
 * pick up the new visibility (other recruiters now seeing/not seeing
 * the job in their lists). */
export function useSetJobRecruiters(): UseMutationResult<Job, Error, SetJobRecruitersInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input) => client.setJobRecruiters(input),
    onSuccess: (job) => {
      qc.setQueryData(queryKeys.job(job.id), job);
      qc.invalidateQueries({ queryKey: ["jobs"] });
    },
  });
}
